// Single place to replace images / contact details later
export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/1431cce6f88c7dcc53f451e55ba117acfc2358c4bcf1350d9d51edd487785e13.jpeg",
  pmFamily: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/0b1919b1a20d2694ceee6391e0990ed4292514a395b17240e68e24c28fb983eb.jpeg",
  coldStorage: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/d154612462c8573d26c2cf78429136997bf9bb5e2c77df11769e2c43987f5832.jpeg",
  riceMill: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/c09f8e4d6dc0d7739af5e8fa195872f3d307642ae3c33d2521135b0454827721.jpeg",
  family: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/e1b6dca0555fd58163a44d1100044b70786c5ffd7b4374e52a4fb94f47abdf71.jpeg",
  school: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/ea4edf0924b9a0f9e27954afd01f872ed826cf02278e62863c38b2183d31a8fd.jpeg",
  poultry: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/3aae1556026761f28947a86804a7e11298f878f69a8049147038d491d30ca8b3.jpeg",
  petrol: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/61cf572eb7d5d05ffe5e6dd4eae060d571851ff0507159d992d62972d0f6e824.jpeg",
  hospital: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/7913467764cc824e2a37baa615c2077303fb71a4cc50fb0058c00d96fa8d4614.jpeg",
  textile: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/d00edcdd5ef37b0cf71d85415c03834ead2a4ae0ff18ca0ec132b371771b3e34.jpeg",
  technicians: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/2bb48d9349c0175e7b2ea0411b6e135c600d5aab3346bef7e48edd383b3e379f.jpeg",
  battery: "https://static.prod-images.emergentagent.com/jobs/fef18a4b-f8b3-426c-b0b9-fe9946797514/images/c4892a6586c918d48ff1c1fabb4b7050ae33ee723936ad2654ab2dd28bb91adb.jpeg",
};

const WA_TEXT = "नमस्ते Anuj Solar, मुझे सोलर की जानकारी चाहिए";
const ADDRESS = "Near UDA Office, Moti Nagar, Unnao, Uttar Pradesh";

export const CONTACT = {
  phone: "9889898935",
  phoneDisplay: "+91 98898 98935",
  tel: "tel:+919889898935",
  whatsapp: `https://wa.me/919889898935?text=${encodeURIComponent(WA_TEXT)}`,
  address: ADDRESS,
  mapLink: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`,
};

// Brand logos (local files in public/brands). logo: null -> styled text tile. h: per-logo visual height tweak
export const BRANDS = [
  { name: "Luminous", logo: "/brands/luminous.svg" },
  { name: "Microtek", logo: "/brands/microtek.svg" },
  { name: "Exide", logo: "/brands/exide.svg" },
  { name: "Havells", logo: "/brands/havells.svg" },
  { name: "Waaree", logo: "/brands/waaree.png", h: "h-12" },
  { name: "Vikram Solar", logo: "/brands/vikram-solar.svg", h: "h-12" },
  { name: "Adani Solar", logo: "/brands/adani.svg" },
  { name: "Smarten", logo: "/brands/smarten.svg", h: "h-8" },
  { name: "Eastman", logo: "/brands/eastman.svg", h: "h-14" },
  { name: "Livguard", logo: "/brands/livguard.svg" },
  { name: "Genus", logo: "/brands/genus.webp", h: "h-12" },
  { name: "Wallpent Solar", logo: "/brands/wallpent-solar.png", h: "h-12" },
  { name: "Tata Power Solar", logo: "/brands/tata-power-solar.svg", h: "h-14" },
  { name: "Loom Solar", logo: "/brands/loom-solar.png" },
  { name: "Goldi Solar", logo: "/brands/goldi-solar.png", h: "h-12" },
  { name: "Rayzon Solar", logo: "/brands/rayzon-solar.png" },
  { name: "Saatvik Solar", logo: "/brands/saatvik-solar.png" },
  { name: "UTL Solar", logo: "/brands/utl-solar.png", h: "h-8" },
  { name: "Servotech", logo: "/brands/servotech.png", h: "h-12" },
  { name: "RenewSys", logo: "/brands/renewsys.png", h: "h-14" },
];

export const openChat = () => window.dispatchEvent(new Event("open-chat"));
